import { createForm } from 'Cloud/Application/Editor/MyOffice/helpers/createForm';
import { sendMyofficeGa } from 'Cloud/Application/Editor/MyOffice/helpers/sendMyofficeGa';
import { IInitMyoffice } from 'Cloud/Application/Editor/MyOffice/myOffice.types';

export const initAndLoadWopi = ({
    container,
    iframeWopi,
    iframeId,
    listeners: { onLoad },
    isMyOfficeForMail,
    wopiParams,
    isEditAttaches,
}: IInitMyoffice & { iframeId: string }): (() => void) => {
    const { accessParams: inputs, postContentType, url: action } = wopiParams || {};

    const form = createForm({
        container,
        action,
        inputs,
        target: iframeId,
        postContentType,
    });

    iframeWopi?.addEventListener('load', () => {
        sendMyofficeGa(`wopi-iframe-load${isMyOfficeForMail ? '-attach' : ''}${isEditAttaches ? '-edit' : '-view'}`);
    });

    form.submit();
    onLoad();

    return onLoad;
};
